<template>
	<el-container class="layout-container flex-center">
		<Headers v-if="!fullScreen" />
		<el-container class="layout-mian-height-50">
			<Asides v-if="!fullScreen" />
			<div class="flex-center layout-backtop">
				<Breadcrumb v-if="!fullScreen" />
				<Mains />
			</div>
		</el-container>
		<el-backtop target=".layout-backtop .el-main .el-scrollbar__wrap"></el-backtop>
	</el-container>
</template>

<script>
import Asides from '@/layout/component/aside.vue';
import Headers from '@/layout/component/header.vue';
import Mains from '@/layout/component/main.vue';
import Breadcrumb from '@/layout/navBars/breadcrumb/breadcrumb.vue';
import screenfull from 'screenfull';


export default {
	data() {
		return {
			pathUrl: '',
      fullScreen: false
		};
	},
	name: 'layoutClassic',
	components: { Asides, Headers, Mains, Breadcrumb },
	computed: {
		// 获取布局配置信息
		getThemeConfig() {
			return this.$store.state.themeConfig.themeConfig;
		},
	},
  mounted() {
    screenfull.on('change', (e) => {
      this.fullScreen = screenfull.isFullscreen
    })
  },
	// 监听路由的变化
	watch: {
		$route: {
			handler(newVal) {
				this.pathUrl = newVal.path;
			},
			deep: true,
		},
	},
};
</script>
